// import { RecaptchaVerifier } from "firebase/auth";
// import { auth } from "./firebase";

// class RecaptchaVerifierManager {
//   private static instance: RecaptchaVerifierManager | null = null;
//   private recaptchaVerifiers: Map<string, RecaptchaVerifier> = new Map();

//   private constructor() {}

//   /**
//    * Singleton Instance
//    * Ensures only one instance of RecaptchaVerifierManager exists.
//    */
//   public static getInstance(): RecaptchaVerifierManager {
//     if (!RecaptchaVerifierManager.instance) {
//       RecaptchaVerifierManager.instance = new RecaptchaVerifierManager();
//     }
//     return RecaptchaVerifierManager.instance;
//   }

//   /**
//    * Initializes the RecaptchaVerifier on a specific container.
//    * Creates a new verifier for each container ID to avoid conflicts.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA will render.
//    * @returns The created RecaptchaVerifier instance.
//    */
//   public setupRecaptcha(containerId: string): RecaptchaVerifier {
//     if (!auth) {
//       throw new Error("Firebase auth is not initialized.");
//     }

//     // Check if we already have a verifier for this container
//     if (this.recaptchaVerifiers.has(containerId)) {
//       try {
//         // Try to clear existing verifier
//         this.clearRecaptchaById(containerId);
//       } catch (error) {
//         console.warn(
//           `Failed to clear existing reCAPTCHA for ${containerId}:`,
//           error
//         );
//       }
//     }

//     try {
//       // Initialize a new RecaptchaVerifier instance
//       const verifier = new RecaptchaVerifier(auth, containerId, {
//         size: "invisible", // Options: 'invisible', 'compact', or 'normal'
//         callback: (response: string) => {
//           console.log("Recaptcha solved successfully");
//         },
//         "expired-callback": () => {
//           console.warn("Recaptcha expired. Please try again.");
//         },
//         "error-callback": (error: any) => {
//           console.error("Recaptcha encountered an error:", error);
//         },
//       });

//       // Store this verifier with its container ID
//       this.recaptchaVerifiers.set(containerId, verifier);

//       return verifier;
//     } catch (error) {
//       console.error(`Error creating reCAPTCHA for ${containerId}:`, error);
//       throw error;
//     }
//   }

//   /**
//    * Clears a specific RecaptchaVerifier instance by container ID.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA was rendered.
//    */
//   public clearRecaptchaById(containerId: string): void {
//     const verifier = this.recaptchaVerifiers.get(containerId);
//     if (verifier) {
//       try {
//         verifier.clear();
//         this.recaptchaVerifiers.delete(containerId);
//         console.log(`Cleared reCAPTCHA for ${containerId}`);
//       } catch (error) {
//         console.warn(`Error clearing reCAPTCHA for ${containerId}:`, error);

//         // Remove from our map even if clearing failed
//         this.recaptchaVerifiers.delete(containerId);

//         // Try to clean up manually
//         try {
//           // Remove grecaptcha elements
//           const grecaptchaElements = document.querySelectorAll(
//             ".grecaptcha-badge, .grecaptcha-logo"
//           );
//           grecaptchaElements.forEach((el) => el.remove());

//           // Clear the container if it exists
//           const container = document.getElementById(containerId);
//           if (container) {
//             container.innerHTML = "";
//           }
//         } catch (cleanupError) {
//           console.warn("Manual reCAPTCHA cleanup failed:", cleanupError);
//         }
//       }
//     }
//   }

//   /**
//    * Clears all RecaptchaVerifier instances.
//    */
//   public clearAllRecaptchas(): void {
//     // Get all container IDs
//     const containerIds = Array.from(this.recaptchaVerifiers.keys());

//     // Clear each verifier
//     containerIds.forEach((id) => {
//       this.clearRecaptchaById(id);
//     });
//   }

//   /**
//    * Retrieves a RecaptchaVerifier instance by container ID.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA was rendered.
//    * @returns The RecaptchaVerifier instance, or null if none exists for this container.
//    */
//   public getRecaptchaVerifierById(
//     containerId: string
//   ): RecaptchaVerifier | undefined {
//     return this.recaptchaVerifiers.get(containerId);
//   }
// }

// // 2nd last change: Export the singleton instance
// export default RecaptchaVerifierManager.getInstance();

// import { RecaptchaVerifier } from "firebase/auth";
// import { auth } from "./firebase";

// class RecaptchaVerifierManager {
//   private static instance: RecaptchaVerifierManager | null = null;
//   private recaptchaVerifiers: Map<string, RecaptchaVerifier> = new Map();
//   private lastUsedContainerId: string | null = null;

//   private constructor() {}

//   /**
//    * Singleton Instance
//    * Ensures only one instance of RecaptchaVerifierManager exists.
//    */
//   public static getInstance(): RecaptchaVerifierManager {
//     if (!RecaptchaVerifierManager.instance) {
//       RecaptchaVerifierManager.instance = new RecaptchaVerifierManager();
//     }
//     return RecaptchaVerifierManager.instance;
//   }

//   /**
//    * Initializes the RecaptchaVerifier on a specific container.
//    * Creates a new verifier for each container ID to avoid conflicts.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA will render.
//    * @returns The created RecaptchaVerifier instance.
//    */
//   public setupRecaptcha(containerId: string): RecaptchaVerifier {
//     if (!auth) {
//       throw new Error("Firebase auth is not initialized.");
//     }

//     // Check if we already have a verifier for this container
//     if (this.recaptchaVerifiers.has(containerId)) {
//       try {
//         // Try to clear existing verifier
//         this.clearRecaptchaById(containerId);
//       } catch (error) {
//         console.warn(
//           `Failed to clear existing reCAPTCHA for ${containerId}:`,
//           error
//         );
//       }
//     }

//     try {
//       // Remember this is our most recently used container
//       this.lastUsedContainerId = containerId;

//       // Make sure the container exists and is properly positioned
//       this.ensureContainerExists(containerId);

//       // Initialize a new RecaptchaVerifier instance with improved settings
//       const verifier = new RecaptchaVerifier(auth, containerId, {
//         size: "invisible",
//         // Add language setting to improve UX
//         hl: "en",
//         // Improve rendering timeout
//         timeout: 30000,
//         callback: (response: string) => {
//           // Don't modify DOM here - let Firebase handle everything
//           // Just notify if needed
//           document.dispatchEvent(
//             new CustomEvent("recaptchaSuccess", { detail: { response } })
//           );
//         },
//         "expired-callback": () => {
//           console.warn("Recaptcha expired. Please try again.");
//           document.dispatchEvent(new CustomEvent("recaptchaExpired"));
//         },
//         "error-callback": (error: any) => {
//           console.error("Recaptcha encountered an error:", error);
//           document.dispatchEvent(
//             new CustomEvent("recaptchaError", { detail: { error } })
//           );
//         },
//       });

//       // Store this verifier with its container ID
//       this.recaptchaVerifiers.set(containerId, verifier);

//       // Store in sessionStorage that we've initialized a reCAPTCHA
//       try {
//         sessionStorage.setItem("recaptcha_initialized", "true");
//         sessionStorage.setItem("recaptcha_container", containerId);
//       } catch (e) {
//         console.warn("Could not access sessionStorage", e);
//       }

//       return verifier;
//     } catch (error) {
//       console.error(`Error creating reCAPTCHA for ${containerId}:`, error);
//       throw error;
//     }
//   }

//   /**
//    * Ensures the container element exists and is properly positioned
//    * for optimal reCAPTCHA behavior.
//    */
//   private ensureContainerExists(containerId: string): void {
//     let container = document.getElementById(containerId);

//     if (!container) {
//       // Create container if it doesn't exist
//       container = document.createElement("div");
//       container.id = containerId;
//       document.body.appendChild(container);
//     }

//     // Position it optimally for invisible reCAPTCHA
//     container.style.position = "fixed";
//     container.style.bottom = "10px";
//     container.style.right = "10px";
//     container.style.zIndex = "1000";
//     container.style.opacity = "0.01";
//     container.style.pointerEvents = "none";
//     container.style.height = "70px";
//     container.style.width = "70px";
//     container.style.overflow = "hidden";

//     // Apply Apple-specific settings if needed
//     this.applyAppleSpecificSettings(containerId);
//   }

//   /**
//    * Apply Apple-specific container settings if needed
//    */
//   private applyAppleSpecificSettings(containerId: string): void {
//     const isAppleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent);
//     if (!isAppleDevice) return;

//     const container = document.getElementById(containerId);
//     if (container) {
//       container.style.position = "fixed";
//       container.style.bottom = "0";
//       container.style.right = "0";
//       container.style.zIndex = "2000";
//       container.style.opacity = "0.02"; // Slightly more visible
//       container.style.height = "100px"; // Larger container
//       container.style.width = "100px";
//     }
//   }

//   /**
//    * Clears a specific RecaptchaVerifier instance by container ID.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA was rendered.
//    */
//   public clearRecaptchaById(containerId: string): void {
//     const verifier = this.recaptchaVerifiers.get(containerId);
//     if (verifier) {
//       try {
//         verifier.clear();
//         this.recaptchaVerifiers.delete(containerId);

//         if (this.lastUsedContainerId === containerId) {
//           this.lastUsedContainerId = null;
//         }
//       } catch (error) {
//         console.warn(`Error clearing reCAPTCHA for ${containerId}:`, error);

//         // Remove from our map even if clearing failed
//         this.recaptchaVerifiers.delete(containerId);

//         // Try to clean up with gentler approach
//         this.performGentleCleanup(containerId);
//       }
//     }
//   }

//   /**
//    * Performs a more gentle cleanup without aggressive DOM manipulation
//    */
//   private performGentleCleanup(containerId: string): void {
//     try {
//       // Just hide the container rather than removing elements
//       const container = document.getElementById(containerId);
//       if (container) {
//         container.style.display = "none";
//       }

//       // Mark container as cleared in sessionStorage
//       try {
//         if (sessionStorage.getItem("recaptcha_container") === containerId) {
//           sessionStorage.removeItem("recaptcha_container");
//         }
//       } catch (e) {
//         console.warn("Could not access sessionStorage", e);
//       }
//     } catch (cleanupError) {
//       console.warn("Gentle reCAPTCHA cleanup failed:", cleanupError);
//     }
//   }

//   /**
//    * Clears all RecaptchaVerifier instances.
//    */
//   public clearAllRecaptchas(): void {
//     // Get all container IDs
//     const containerIds = Array.from(this.recaptchaVerifiers.keys());

//     // Clear each verifier
//     containerIds.forEach((id) => {
//       this.clearRecaptchaById(id);
//     });

//     this.lastUsedContainerId = null;

//     // Clear session storage markers
//     try {
//       sessionStorage.removeItem("recaptcha_initialized");
//       sessionStorage.removeItem("recaptcha_container");
//     } catch (e) {
//       console.warn("Could not access sessionStorage", e);
//     }

//     // Additional cleanup for timeout issues
//     try {
//       // Clear any grecaptcha global variables that might be causing timeouts
//       if (window.hasOwnProperty("grecaptcha")) {
//         // @ts-ignore - using any to access grecaptcha
//         const grecaptcha = window["grecaptcha"];
//         if (grecaptcha && typeof grecaptcha.reset === "function") {
//           try {
//             grecaptcha.reset();
//           } catch (resetErr) {
//             console.warn("Error resetting grecaptcha:", resetErr);
//           }
//         }
//       }

//       // Add a defensive timeout to ensure cleanup runs even if navigation happens
//       setTimeout(() => {
//         // Clear any remaining iframes or badges
//         document
//           .querySelectorAll('iframe[src*="recaptcha"], .grecaptcha-badge')
//           .forEach((el) => {
//             try {
//               (el as HTMLElement).style.display = "none";
//               if (el.parentNode) {
//                 el.parentNode.removeChild(el);
//               }
//             } catch (e) {
//               console.warn("Error removing reCAPTCHA element:", e);
//             }
//           });
//       }, 0);
//     } catch (globalCleanupErr) {
//       console.warn("Error during global reCAPTCHA cleanup:", globalCleanupErr);
//     }
//   }

//   /**
//    * Retrieves a RecaptchaVerifier instance by container ID.
//    *
//    * @param containerId - The HTML element ID where the reCAPTCHA was rendered.
//    * @returns The RecaptchaVerifier instance, or undefined if none exists for this container.
//    */
//   public getRecaptchaVerifierById(
//     containerId: string
//   ): RecaptchaVerifier | undefined {
//     return this.recaptchaVerifiers.get(containerId);
//   }

//   /**
//    * Gets the most recently used container ID
//    * @returns The most recently used container ID, or null if none used yet
//    */
//   public getLastUsedContainerId(): string | null {
//     return this.lastUsedContainerId;
//   }
// }

// // Export the singleton instance
// export default RecaptchaVerifierManager.getInstance();

import { RecaptchaVerifier } from "firebase/auth";
import { auth } from "./firebase";

// Enterprise reCAPTCHA configuration interface
interface EnterpriseRecaptchaConfig {
  siteKey?: string;
  useEnterprise: boolean;
  domain: string;
  trustSignals: any;
}

class RecaptchaVerifierManager {
  private static instance: RecaptchaVerifierManager | null = null;
  private recaptchaVerifiers: Map<string, RecaptchaVerifier> = new Map();
  private lastUsedContainerId: string | null = null;
  private enterpriseConfig: EnterpriseRecaptchaConfig | null = null;
  private isAppleDevice: boolean = false;
  private isSafari: boolean = false;
  private initializationAttempts: number = 0;
  private maxRetryAttempts: number = 3;

  private constructor() {
    this.detectDeviceAndBrowser();
    this.setupGlobalErrorHandling();
    this.preloadRecaptchaScript();
  }

  /**
   * Singleton Instance
   */
  public static getInstance(): RecaptchaVerifierManager {
    if (!RecaptchaVerifierManager.instance) {
      RecaptchaVerifierManager.instance = new RecaptchaVerifierManager();
    }
    return RecaptchaVerifierManager.instance;
  }

  /**
   * Detect device and browser for optimized configuration
   */
  private detectDeviceAndBrowser(): void {
    this.isAppleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent);
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (this.isAppleDevice || this.isSafari) {
      console.log(
        "🍎 Apple/Safari device detected - Using enhanced compatibility mode"
      );
    }
  }

  /**
   * Set up global error handling for reCAPTCHA
   */
  private setupGlobalErrorHandling(): void {
    // Handle global reCAPTCHA errors
    window.addEventListener("error", (event) => {
      if (
        event.message?.includes("recaptcha") ||
        event.message?.includes("grecaptcha")
      ) {
        console.warn(
          "🔄 reCAPTCHA error detected, will retry with fresh instance:",
          event.message
        );
        this.handleRecaptchaError(event.error);
      }
    });

    // Handle unhandled promise rejections related to reCAPTCHA
    window.addEventListener("unhandledrejection", (event) => {
      if (event.reason?.toString().includes("recaptcha")) {
        console.warn(
          "🔄 reCAPTCHA promise rejection, will retry:",
          event.reason
        );
        this.handleRecaptchaError(event.reason);
      }
    });
  }

  /**
   * Preload reCAPTCHA script for faster initialization
   */
  private preloadRecaptchaScript(): void {
    try {
      // Check if script is already loaded
      if (document.querySelector('script[src*="recaptcha"]')) {
        return;
      }

      // Create and inject reCAPTCHA script with enhanced parameters
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=explicit&hl=en`;
      script.async = true;
      script.defer = true;

      // Add error handling
      script.onerror = () => {
        console.warn("❌ Failed to preload reCAPTCHA Enterprise script");
      };

      script.onload = () => {
        localStorage.setItem("recaptcha_script_loaded", "true");
      };

      document.head.appendChild(script);
    } catch (e) {
      console.warn("Could not preload reCAPTCHA script:", e);
    }
  }

  /**
   * Handle reCAPTCHA errors with intelligent retry logic
   */
  private handleRecaptchaError(error: any): void {
    try {
      // Clear any stuck instances
      this.clearAllRecaptchas();

      // Reset initialization attempts if too many
      if (this.initializationAttempts >= this.maxRetryAttempts) {
        this.initializationAttempts = 0;
      }

      // Store error info for debugging
      localStorage.setItem(
        "last_recaptcha_error",
        JSON.stringify({
          error: error?.toString() || "unknown",
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          attempts: this.initializationAttempts,
        })
      );
    } catch (e) {
      console.warn("Error in reCAPTCHA error handler:", e);
    }
  }

  /**
   * Enhanced reCAPTCHA setup with Enterprise support and device optimization
   */
  public setupRecaptcha(containerId: string): RecaptchaVerifier {
    if (!auth) {
      throw new Error("Firebase auth is not initialized.");
    }

    // Increment attempt counter
    this.initializationAttempts++;

    // Check if we already have a verifier for this container
    if (this.recaptchaVerifiers.has(containerId)) {
      try {
        this.clearRecaptchaById(containerId);
      } catch (error) {
        console.warn(
          `Failed to clear existing reCAPTCHA for ${containerId}:`,
          error
        );
      }
    }

    try {
      this.lastUsedContainerId = containerId;
      this.ensureContainerExists(containerId);

      // Get enhanced configuration based on device and enterprise settings
      const recaptchaConfig = this.getOptimizedRecaptchaConfig();

      // Create enhanced RecaptchaVerifier with device-specific optimizations
      const verifier = new RecaptchaVerifier(auth, containerId, {
        size: "invisible",
        hl: "en", // Language setting
        theme: "light", // Explicit theme for consistency
        tabindex: -1, // Prevent focus issues

        // Enhanced timeout based on device
        timeout: this.isAppleDevice || this.isSafari ? 45000 : 30000,

        // Device-specific badge positioning
        badge: this.isAppleDevice ? "bottomright" : "bottomleft",

        // Enhanced callback with better error handling
        callback: (response: string) => {

          // Record successful verification
          localStorage.setItem(
            "recaptcha_success_count",
            (
              parseInt(localStorage.getItem("recaptcha_success_count") || "0") +
              1
            ).toString()
          );
          localStorage.setItem(
            "last_recaptcha_success",
            new Date().toISOString()
          );

          // Reset attempt counter on success
          this.initializationAttempts = 0;

          document.dispatchEvent(
            new CustomEvent("recaptchaSuccess", {
              detail: {
                response,
                timestamp: new Date().toISOString(),
                attempts: this.initializationAttempts,
              },
            })
          );
        },

        "expired-callback": () => {
          console.warn("⏰ reCAPTCHA expired. User needs to verify again.");
          localStorage.setItem(
            "recaptcha_expired_count",
            (
              parseInt(localStorage.getItem("recaptcha_expired_count") || "0") +
              1
            ).toString()
          );

          document.dispatchEvent(
            new CustomEvent("recaptchaExpired", {
              detail: { timestamp: new Date().toISOString() },
            })
          );
        },

        "error-callback": (error: any) => {
          console.error("❌ reCAPTCHA error:", error);

          // Enhanced error tracking
          localStorage.setItem(
            "recaptcha_error_count",
            (
              parseInt(localStorage.getItem("recaptcha_error_count") || "0") + 1
            ).toString()
          );
          localStorage.setItem(
            "last_recaptcha_error_time",
            new Date().toISOString()
          );

          this.handleRecaptchaError(error);

          document.dispatchEvent(
            new CustomEvent("recaptchaError", {
              detail: {
                error,
                timestamp: new Date().toISOString(),
                canRetry: this.initializationAttempts < this.maxRetryAttempts,
              },
            })
          );
        },

        // Enhanced isolated parameter for better Safari compatibility
        isolated: this.isSafari,
      });

      // Store verifier with container ID
      this.recaptchaVerifiers.set(containerId, verifier);

      // Enhanced session storage tracking
      try {
        sessionStorage.setItem("recaptcha_initialized", "true");
        sessionStorage.setItem("recaptcha_container", containerId);
        sessionStorage.setItem("recaptcha_init_time", new Date().toISOString());
        sessionStorage.setItem(
          "recaptcha_device_type",
          this.isAppleDevice ? "apple" : "other"
        );
      } catch (e) {
        console.warn(
          "Could not access sessionStorage for reCAPTCHA tracking",
          e
        );
      }

      // Additional Enterprise-specific setup
      this.setupEnterpriseFeatures(containerId);

      return verifier;
    } catch (error) {
      console.error(`❌ Error creating reCAPTCHA for ${containerId}:`, error);

      // Enhanced retry logic
      if (this.initializationAttempts < this.maxRetryAttempts) {
        console.log(
          `🔄 Retrying reCAPTCHA initialization (attempt ${this.initializationAttempts}/${this.maxRetryAttempts})`
        );

        // Wait before retry, with exponential backoff
        setTimeout(() => {
          try {
            return this.setupRecaptcha(containerId);
          } catch (retryError) {
            console.error("❌ Retry failed:", retryError);
            throw retryError;
          }
        }, Math.pow(2, this.initializationAttempts) * 1000);
      }

      throw error;
    }
  }

  /**
   * Get optimized reCAPTCHA configuration based on device and enterprise settings
   */
  private getOptimizedRecaptchaConfig() {
    const baseConfig = {
      size: "invisible" as const,
      theme: "light" as const,
      hl: "en",
    };

    // Apple/Safari specific optimizations
    if (this.isAppleDevice || this.isSafari) {
      return {
        ...baseConfig,
        isolated: true, // Better Safari compatibility
        timeout: 45000, // Longer timeout for iOS
        badge: "bottomright" as const, // Better positioning for iOS
        tabindex: -1, // Prevent focus issues
      };
    }

    // Android/Chrome optimizations
    return {
      ...baseConfig,
      timeout: 30000,
      badge: "bottomleft" as const,
      fast: true, // Enable fast mode if available
    };
  }

  /**
   * Set up Enterprise-specific features
   */
  private setupEnterpriseFeatures(containerId: string): void {
    try {
      // Set up enterprise scoring if available
      if (
        window.hasOwnProperty("grecaptcha") &&
        this.enterpriseConfig?.useEnterprise
      ) {
        // @ts-ignore - Enterprise API access
        const grecaptcha = window["grecaptcha"];

        if (grecaptcha.enterprise) {

          // Set up enhanced scoring
          localStorage.setItem("recaptcha_enterprise_enabled", "true");
        }
      }

      // Enhanced trust signal reporting
      this.reportTrustSignals(containerId);
    } catch (e) {
      console.warn("Could not set up enterprise features:", e);
    }
  }

  /**
   * Report trust signals to improve reCAPTCHA scoring
   */
  private reportTrustSignals(containerId: string): void {
    try {
      const trustSignals = {
        domain: window.location.hostname,
        userInteractionScore:
          localStorage.getItem("user_interaction_score") || "0",
        loginHistory: localStorage.getItem("login_count") || "0",
        deviceType: this.isAppleDevice ? "apple" : "other",
        browserType: this.isSafari ? "safari" : "other",
        sessionLength: this.calculateSessionLength(),
        humanBehaviorDetected:
          localStorage.getItem("human_behavior_detected") === "true",
      };

      // Store trust signals for this session
      sessionStorage.setItem(
        `trust_signals_${containerId}`,
        JSON.stringify(trustSignals)
      );
    } catch (e) {
      console.warn("Could not report trust signals:", e);
    }
  }

  /**
   * Calculate current session length for trust scoring
   */
  private calculateSessionLength(): number {
    try {
      const sessionStart = sessionStorage.getItem("session_start_time");
      if (sessionStart) {
        return Date.now() - new Date(sessionStart).getTime();
      }

      // Set session start time if not exists
      sessionStorage.setItem("session_start_time", new Date().toISOString());
      return 0;
    } catch (e) {
      return 0;
    }
  }

  /**
   * Enhanced container creation with device-specific optimizations
   */
  private ensureContainerExists(containerId: string): void {
    let container = document.getElementById(containerId);

    if (!container) {
      container = document.createElement("div");
      container.id = containerId;
      document.body.appendChild(container);
    }

    // Device-specific styling
    if (this.isAppleDevice || this.isSafari) {
      // iOS/Safari optimized positioning
      container.style.position = "fixed";
      container.style.bottom = "0";
      container.style.right = "0";
      container.style.zIndex = "2147483647"; // Maximum z-index for iOS
      container.style.opacity = "0.01";
      container.style.pointerEvents = "none";
      container.style.height = "78px"; // Larger for better iOS compatibility
      container.style.width = "78px";
      container.style.overflow = "hidden";
      container.style.border = "none";
      container.style.margin = "0";
      container.style.padding = "0";

      // Additional iOS-specific styles
      container.style.webkitTransform = "translateZ(0)"; // Hardware acceleration
      container.style.transform = "translateZ(0)";
      container.style.webkitBackfaceVisibility = "hidden";
      container.style.backfaceVisibility = "hidden";
    } else {
      // Standard positioning for other devices
      container.style.position = "fixed";
      container.style.bottom = "10px";
      container.style.right = "10px";
      container.style.zIndex = "1000";
      container.style.opacity = "0.01";
      container.style.pointerEvents = "none";
      container.style.height = "70px";
      container.style.width = "70px";
      container.style.overflow = "hidden";
    }

    // Add accessibility attributes
    container.setAttribute("aria-hidden", "true");
    container.setAttribute("role", "presentation");

    // Add data attributes for debugging
    container.setAttribute("data-recaptcha-container", "true");
    container.setAttribute(
      "data-device-type",
      this.isAppleDevice ? "apple" : "other"
    );
    container.setAttribute(
      "data-browser-type",
      this.isSafari ? "safari" : "other"
    );
  }

  /**
   * Enhanced cleanup for specific container
   */
  public clearRecaptchaById(containerId: string): void {
    const verifier = this.recaptchaVerifiers.get(containerId);
    if (verifier) {
      try {
        verifier.clear();
        this.recaptchaVerifiers.delete(containerId);

        if (this.lastUsedContainerId === containerId) {
          this.lastUsedContainerId = null;
        }

      } catch (error) {
        console.warn(`⚠️ Error clearing reCAPTCHA for ${containerId}:`, error);

        // Force removal from map even if clearing failed
        this.recaptchaVerifiers.delete(containerId);
        this.performGentleCleanup(containerId);
      }
    }
  }

  /**
   * Enhanced gentle cleanup with better error handling
   */
  private performGentleCleanup(containerId: string): void {
    try {
      const container = document.getElementById(containerId);
      if (container) {
        // Hide and clear content
        container.style.display = "none";
        container.style.visibility = "hidden";
        container.innerHTML = "";

        // Add a comment marker for debugging
        const comment = document.createComment(
          `reCAPTCHA container ${containerId} cleaned up at ${new Date().toISOString()}`
        );
        container.appendChild(comment);
      }

      // Clean session storage
      try {
        const keysToRemove = [
          "recaptcha_container",
          `trust_signals_${containerId}`,
          "recaptcha_init_time",
        ];

        keysToRemove.forEach((key) => {
          if (
            sessionStorage.getItem(key) === containerId ||
            key.includes(containerId)
          ) {
            sessionStorage.removeItem(key);
          }
        });
      } catch (e) {
        console.warn(
          "Could not clean sessionStorage during gentle cleanup:",
          e
        );
      }

      // Record cleanup event
      localStorage.setItem("last_recaptcha_cleanup", new Date().toISOString());
    } catch (cleanupError) {
      console.warn("Enhanced gentle cleanup failed:", cleanupError);
    }
  }

  /**
   * Enhanced clear all with better global cleanup
   */
  public clearAllRecaptchas(): void {
    const containerIds = Array.from(this.recaptchaVerifiers.keys());

    containerIds.forEach((id) => {
      this.clearRecaptchaById(id);
    });

    this.lastUsedContainerId = null;

    // Enhanced session storage cleanup
    try {
      const keysToRemove = [
        "recaptcha_initialized",
        "recaptcha_container",
        "recaptcha_init_time",
        "session_start_time",
      ];

      keysToRemove.forEach((key) => {
        sessionStorage.removeItem(key);
      });
    } catch (e) {
      console.warn("Could not clean sessionStorage:", e);
    }

    // Enhanced global cleanup
    this.performGlobalCleanup();
  }

  /**
   * Comprehensive global cleanup for stuck reCAPTCHA elements
   */
  private performGlobalCleanup(): void {
    try {
      // Clean up any remaining reCAPTCHA elements
      const selectors = [
        'iframe[src*="recaptcha"]',
        ".grecaptcha-badge",
        "[data-recaptcha-container]",
        'div[id*="recaptcha"]',
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          try {
            (el as HTMLElement).style.display = "none";
            (el as HTMLElement).style.visibility = "hidden";

            // Remove from DOM if it's safe to do so
            if (el.parentNode && !el.hasAttribute("data-keep")) {
              el.parentNode.removeChild(el);
            }
          } catch (e) {
            console.warn(`Error cleaning reCAPTCHA element:`, e);
          }
        });
      });

      // Global grecaptcha reset if available
      if (window.hasOwnProperty("grecaptcha")) {
        try {
          // @ts-ignore - Global reset
          const grecaptcha = window["grecaptcha"];
          if (grecaptcha && typeof grecaptcha.reset === "function") {
            grecaptcha.reset();
          }
        } catch (resetErr) {
          console.warn("Error performing global reCAPTCHA reset:", resetErr);
        }
      }

      // Record cleanup completion
      localStorage.setItem(
        "global_recaptcha_cleanup",
        new Date().toISOString()
      );
    } catch (globalCleanupErr) {
      console.warn("Error during global reCAPTCHA cleanup:", globalCleanupErr);
    }
  }

  /**
   * Get verifier by container ID
   */
  public getRecaptchaVerifierById(
    containerId: string
  ): RecaptchaVerifier | undefined {
    return this.recaptchaVerifiers.get(containerId);
  }

  /**
   * Get the most recently used container ID
   */
  public getLastUsedContainerId(): string | null {
    return this.lastUsedContainerId;
  }

  /**
   * Check if reCAPTCHA is ready for the given container
   */
  public isRecaptchaReady(containerId: string): boolean {
    const verifier = this.recaptchaVerifiers.get(containerId);
    const container = document.getElementById(containerId);

    return !!(
      verifier &&
      container &&
      !container.hasAttribute("data-clearing")
    );
  }

  /**
   * Get current initialization status
   */
  public getInitializationStatus() {
    return {
      attempts: this.initializationAttempts,
      maxAttempts: this.maxRetryAttempts,
      canRetry: this.initializationAttempts < this.maxRetryAttempts,
      activeVerifiers: this.recaptchaVerifiers.size,
      isAppleDevice: this.isAppleDevice,
      isSafari: this.isSafari,
      lastUsedContainer: this.lastUsedContainerId,
    };
  }

  /**
   * Set enterprise configuration
   */
  public setEnterpriseConfig(config: EnterpriseRecaptchaConfig): void {
    this.enterpriseConfig = config;
  }
}

// Export the singleton instance
export default RecaptchaVerifierManager.getInstance();
